import { FloorGameActivity } from '@pkg/types/floorGame';
import { arrayOfLength } from '@pkg/utils';

import { type CollectionListingsItem } from '@app/client/resources/collections/types';

import { activityToTickStatus, type TickProps } from './components';
import { tokens } from './tokens';
import { type FloorGameTicksOptions } from './types';

export function useFloorGameTicks(
    id: string,
    listings: CollectionListingsItem[],
    { size, totalListingsInTier = 0, activity = FloorGameActivity.Quiet }: FloorGameTicksOptions,
) {
    const status = activityToTickStatus(activity);

    // TODO: If we are okay with passing in ALL "listings within tiers"
    // as `listings`, then we can remove the separate `totalListingsInTier` prop.
    const totalListings = Math.max(listings.length, totalListingsInTier);
    const meterSize = tokens.meterSize[size];

    const activeTickCount = Math.max(0, meterSize - listings.length);
    const activeTicks: TickProps[] = arrayOfLength(activeTickCount).map((index) => ({
        id: `${id}-Tick-Active-${index}`,
        status,
        active: true,
    }));

    const hasPocket = !activeTickCount && totalListings > meterSize;

    const initialListedCount = meterSize - activeTickCount;
    const adjustedListedCount = hasPocket ? initialListedCount - 1 : initialListedCount;

    // TODO: Should a `pocket` have an `onAction()`?
    const pocketTick: TickProps[] = hasPocket
        ? [
              {
                  id: `${id}-Tick-Pocket`,
                  pocketCount: totalListings - adjustedListedCount,
              },
          ]
        : [];

    // TODO: Determine `onAction()` per Tick.
    const listedTicks: TickProps[] = listings
        .slice(0, adjustedListedCount)
        // `token_id` can be repeated for multiple ticks, so
        // unfortunately we have to include `index` in the `id`.
        .map(({ token_id, active_listing_token }, index) => ({
            id: `${id}-Tick-Listed-${token_id}-${index}`,
            thumbnail: active_listing_token?.image_url ?? undefined,
            status,
        }));

    // This might need to be memoized.
    return [...activeTicks, ...pocketTick, ...listedTicks];
}
